/**
 * Aggiunge il dominio selezionato a un URL di rotta "web" del backend.
 * Serve perché questi URL sono aperti dal browser (<a href> / window.open):
 * non passano da HeadersInterceptor, quindi non portano X-Domain-Id.
 * Il backend legge domain_id in WorkDomainService::getDomainIdFromRequest().
 * No-op quando nessun dominio è selezionato (vista "tutti i domini").
 *
 * Nessun import per scelta: il domainId arriva dal chiamante (che ha già
 * DomainFilterService via DI). Leggerlo qui richiederebbe di importare
 * domain-filter.service, creando il ciclo app.service -> helper -> domain-filter.service.
 */
export function appendDomainId(url: string, domainId: string): string{
	if(!url || !domainId || domainId === 'null') return url;
	if(/[?&]domain_id=/.test(url)) return url;
	return url + (url.includes('?') ? '&' : '?') + 'domain_id=' + encodeURIComponent(domainId);
}
